import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import SearchBar from '../components/SearchBar';
import CategoryList from '../components/CategoryList';

const Home = () => {
  const [categories, setCategories] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          'https://hijabsin.com/wp-json/wc/v3/products/categories?per_page=100&page=1',
          {
            auth: {
              username: 'ck_53f992c38e58c2733ac1d6dfcc3cebcfe5845d49',
              password: 'cs_73f39f1fafa45c544f44ab9f652dac3b822b8149',
            },
          }
        );
        setCategories(response.data);
      } catch (err) {
        console.error('Error fetching product categories:', err);
        setError('Failed to load product categories.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleSearch = async () => {
    const trimmedQuery = searchQuery.trim();

    if (trimmedQuery === '') {
      alert('Please enter a search term.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.get(
        `https://hijabsin.com/wp-json/wc/v3/products?search=${encodeURIComponent(trimmedQuery)}&per_page=100&page=1`,
        {
          auth: {
            username: 'ck_53f992c38e58c2733ac1d6dfcc3cebcfe5845d49',
            password: 'cs_73f39f1fafa45c544f44ab9f652dac3b822b8149',
          },
        }
      );

      setSearchResults(response.data.map((product) => ({
        ...product,
        updatedStock: product.stock_quantity || 0,
      })));
    } catch (error) {
      console.error('Error during search:', error);
      alert('Failed to perform the search. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCategoryClick = (categoryId) => {
    window.location.href = `/category/${categoryId}`;
  };

  const updateStock = (id, increment) => {
    setSearchResults((prevResults) =>
      prevResults.map((product) =>
        product.id === id
          ? { ...product, updatedStock: Math.max(0, product.updatedStock + increment) }
          : product
      )
    );
  };

  const saveStock = async (id) => {
    const product = searchResults.find((p) => p.id === id);
    if (!product) return;

    try {
      await axios.put(
        `https://hijabsin.com/wp-json/wc/v3/products/${id}`,
        { stock_quantity: product.updatedStock },
        {
          auth: {
            username: 'ck_53f992c38e58c2733ac1d6dfcc3cebcfe5845d49',
            password: 'cs_73f39f1fafa45c544f44ab9f652dac3b822b8149',
          },
        }
      );
      alert(`${product.name} stock updated to ${product.updatedStock}.`);
    } catch (error) {
      console.error('Error updating stock:', error);
      alert('Failed to save stock. Please try again.');
    }
  };

  const handleLogout = () => {
    sessionStorage.setItem("isAuthenticated", "false");
    navigate("/"); // Redirect to login page
  };
  return (
    <div className="home-page">
      <div style={{ height: '10vh', backgroundColor: '#fff', display: 'flex', alignItems: 'center', padding: '0 20px' }}>
        <a href="/"><img src="./logo.webp" alt="logo" className="logo" /></a>
        <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} handleSearch={handleSearch} />
      </div>

      <div style={{ height: '85vh', overflowY: 'scroll', padding: '20px' }}>
        {isLoading ? (
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <div className="loader"></div>
            <p>Loading...</p>
          </div>
        ) : searchResults.length > 0 ? (
          <>
            <h1>Search Results</h1>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
              {searchResults.map((product) => (
                <div key={product.id} className="item-box">
                  <div>
                    {product.images[0] && (
                      <img src={product.images[0].src} alt={product.name} style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                    )}
                    <p>Status: {product.stock_status}</p>
                  </div>
                  <div>
                    <h3>{product.name}</h3>
                    <p>Price: ${product.price}</p>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      <div
                        style={{ width: 'fit-content', padding: '5px', border: '1px solid black', backgroundColor: 'orange', cursor: 'pointer' }}
                        onClick={() => updateStock(product.id, -1)}
                      >
                        -
                      </div>
                      <p>Stock: {product.updatedStock}</p>
                      <div
                        style={{ width: 'fit-content', padding: '5px', border: '1px solid black', backgroundColor: 'orange', cursor: 'pointer' }}
                        onClick={() => updateStock(product.id, 1)}
                      >
                        +
                      </div>
                    </div>
                    <div
                      style={{ width: '80%', backgroundColor: 'red', marginTop: '10px', textAlign: 'center', border: '1px solid black', color: '#fff', cursor: 'pointer' }}
                      onClick={() => saveStock(product.id)}
                    >
                      Save
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            <h1>Categories</h1>
            <CategoryList categories={categories} onCategoryClick={handleCategoryClick} />
          </>
        )}
      </div>
      <div style={{width:'100%', padding:'5px', color:'#fff',backgroundColor:'#000',textAlign:'center'}} onClick={handleLogout}>Log Out</div>
    </div>
  );
};

export default Home;
